Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=







autoPlay;var _react=require('react');var _react2=_interopRequireDefault(_react);var _reactAddonsShallowCompare=require('react-addons-shallow-compare');var _reactAddonsShallowCompare2=_interopRequireDefault(_reactAddonsShallowCompare);var _reactSwipeableViewsCore=require('react-swipeable-views-core');function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ignore={};function autoPlay(MyComponent){var
AutoPlay=function(_Component){_inherits(AutoPlay,_Component);function AutoPlay(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AutoPlay);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AutoPlay.__proto__||Object.getPrototypeOf(AutoPlay)).call.apply(_ref,[this].concat(args))),_this),_this.












































state={},_this.














































timer=null,_this.














handleInterval=function(){var _this$props=





_this.props,children=_this$props.children,direction=_this$props.direction,onChangeIndex=_this$props.onChangeIndex,slideCount=_this$props.slideCount;

var indexLatest=_this.state.index;
var indexNew=indexLatest;

if(direction==='incremental'){
indexNew+=1;
}else{
indexNew-=1;
}

if(slideCount||children){
indexNew=(0,_reactSwipeableViewsCore.mod)(indexNew,slideCount||_react.Children.count(children));
}


if(_this.props.index===undefined){
_this.setState({
index:indexNew});

}

if(onChangeIndex){
onChangeIndex(indexNew,indexLatest);
}
},_this.

handleChangeIndex=function(index,indexLatest){

if(_this.props.index===undefined){
_this.setState({
index:index});

}

if(_this.props.onChangeIndex){
_this.props.onChangeIndex(index,indexLatest);
}
},_this.

handleSwitching=function(index,type){
if(_this.timer){
clearInterval(_this.timer);
_this.timer=null;
}else if(type==='end'){
_this.startInterval();
}

if(_this.props.onSwitching){
_this.props.onSwitching(index,type);
}
},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AutoPlay,[{key:'componentWillMount',value:function componentWillMount(){this.setState({index:this.props.index||0});}},{key:'componentDidMount',value:function componentDidMount(){this.startInterval();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var index=nextProps.index;if(typeof index==='number'&&index!==this.props.index){this.setState({index:index});}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var shouldResetInterval=(0,_reactAddonsShallowCompare2.default)({props:{index:prevProps.index,interval:prevProps.interval,autoplay:prevProps.autoplay},state:ignore},{index:this.props.index,interval:this.props.interval,autoplay:this.props.autoplay},ignore);if(shouldResetInterval){this.startInterval();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.timer);}},{key:'startInterval',value:function startInterval(){var _props=this.props,autoplay=_props.autoplay,interval=_props.interval;clearInterval(this.timer);if(autoplay){this.timer=setInterval(this.handleInterval,interval);}}},{key:'render',value:function render()

{var _props2=







this.props,autoplay=_props2.autoplay,direction=_props2.direction,interval=_props2.interval,indexProp=_props2.index,onChangeIndex=_props2.onChangeIndex,other=_objectWithoutProperties(_props2,['autoplay','direction','interval','index','onChangeIndex']);var


index=
this.state.index;

if(!autoplay){
return(
_react2.default.createElement(MyComponent,_extends({
index:index},
other)));


}

return(
_react2.default.createElement(MyComponent,_extends({
index:index,
onChangeIndex:this.handleChangeIndex,
onSwitching:this.handleSwitching},
other)));


}}]);return AutoPlay;}(_react.Component);AutoPlay.propTypes={autoplay:_react.PropTypes.bool,children:_react.PropTypes.node,direction:_react.PropTypes.oneOf(['incremental','decremental']),index:_react.PropTypes.number,interval:_react.PropTypes.number,onChangeIndex:_react.PropTypes.func,onSwitching:_react.PropTypes.func,slideCount:_react.PropTypes.number};AutoPlay.defaultProps={autoplay:true,direction:'incremental',interval:3000};


return AutoPlay;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-swipeable-views-utils/lib/autoPlay.js
// module id = 729
// module chunks = 0